import { formOptions } from '@tanstack/react-form';
import { z } from 'zod';

import { WORKFLOW_CHANNEL_TYPE } from '@/types/workflowConst';

// Notification Channel 전용 Zod 스키마
export const notificationChannelSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal(WORKFLOW_CHANNEL_TYPE.SLACK),
    slack_webhook_id: z
      .string()
      .min(1, { message: 'Please select a channel' }),
  }),
  z.object({
    type: z.literal(WORKFLOW_CHANNEL_TYPE.MAIL),
    mail_address: z.string().email({ message: 'Please enter a valid email' }),
  }),
]);

export type NotificationChannelFormData = {
  channel: z.infer<typeof notificationChannelSchema>;
};

export const notificationChannelFormDefaultValues: NotificationChannelFormData =
  {
    channel: {
      type: WORKFLOW_CHANNEL_TYPE.SLACK,
      slack_webhook_id: '',
    },
  };

// Notification Channel 전용 Form Options
export const notificationChannelFormOptions = formOptions({
  defaultValues: notificationChannelFormDefaultValues,
});
